import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { RowColumnExport } from '../../io/VerySimpleExport/RowColumnExport';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const RowColumnExportWidget = (props) => {
    const component = useMemo(() => _jsx(RowColumnExport, { contextCustomer: props.contextCustomer, object: {}, rowColumnizer: (object) => [], spreadsheetTitle: "RowColumnExport" }), [props.contextCustomer]);
    return {
        name: 'RowColumnExport',
        category: 'composite',
        component,
    };
};
